
export const alertHistory = [
  {
    id: '1',
    type: 'critical',
    parameter: 'pH T',
    message: 'pH fuera del rango seguro - Nivel muy bajo detectado',
    value: 6.2,
    unit: 'pH',
    optimalRange: '6.5-8.4',
    date: '2024-01-15',
    time: '14:30',
    technician: 'María García',
    resolved: true,
    resolution: 'Se agregó regulador de pH y se estabilizó el nivel',
    resolutionTime: '1h 45min'
  },
  {
    id: '2',
    type: 'warning',
    parameter: 'Cloro T',
    message: 'Nivel de cloro por debajo del óptimo',
    value: 0.08,
    unit: 'mg/L Cl2',
    optimalRange: '0.1-6.0',
    date: '2024-01-15',
    time: '10:15',
    technician: 'Carlos López',
    resolved: true,
    resolution: 'Dosificación adicional de cloro aplicada',
    resolutionTime: '45min'
  },
  {
    id: '3',
    type: 'critical',
    parameter: 'Alcalinidad-m T',
    message: 'Alcalinidad extremadamente baja',
    value: 3,
    unit: 'mg/L CaCO3',
    optimalRange: '5-300',
    date: '2024-01-14',
    time: '16:45',
    technician: 'Ana Martín',
    resolved: true,
    resolution: 'Tratamiento con bicarbonato de sodio completado',
    resolutionTime: '2h 30min'
  },
  {
    id: '4',
    type: 'warning',
    parameter: 'CyA T',
    message: 'Estabilizador por debajo del nivel recomendado',
    value: 18,
    unit: 'mg/L CyA',
    optimalRange: '20-120',
    date: '2024-01-14',
    time: '09:00',
    technician: 'María García',
    resolved: true,
    resolution: 'Añadido ácido cianúrico al sistema',
    resolutionTime: '1h 15min'
  },
  {
    id: '5',
    type: 'warning',
    parameter: 'Dureza Calcium (B) T',
    message: 'Dureza de calcio ligeramente elevada',
    value: 520,
    unit: 'mg/L CaCO3',
    optimalRange: '50-500',
    date: '2024-01-13',
    time: '11:30',
    technician: 'Carlos López',
    resolved: false,
    resolution: null,
    resolutionTime: null
  },
  {
    id: '6',
    type: 'critical',
    parameter: 'Fosfato LR T',
    message: 'Nivel de fosfatos muy alto - Riesgo de algas',
    value: 3.5,
    unit: 'mg/L PO4',
    optimalRange: '0.06-3.0',
    date: '2024-01-12',
    time: '15:20',
    technician: 'Ana Martín',
    resolved: true,
    resolution: 'Aplicación de removedor de fosfatos y limpieza de filtros',
    resolutionTime: '3h 10min'
  },
  {
    id: '7',
    type: 'warning',
    parameter: 'Oxígeno Activo T',
    message: 'Oxígeno activo por debajo del nivel óptimo',
    value: 0.15,
    unit: 'mg/L O2',
    optimalRange: '0.2-10',
    date: '2024-01-11',
    time: '08:45',
    technician: 'María García',
    resolved: true,
    resolution: 'Sistema de aireación activado y verificado',
    resolutionTime: '55min'
  },
  {
    id: '8',
    type: 'warning',
    parameter: 'Bromo T',
    message: 'Concentración de bromo elevada',
    value: 14.2,
    unit: 'mg/L Br2',
    optimalRange: '0.2-13.5',
    date: '2024-01-10',
    time: '13:00',
    technician: 'Carlos López',
    resolved: true,
    resolution: 'Dilución parcial del agua y ajuste de dosificador',
    resolutionTime: '2h 00min'
  },
  {
    id: '9',
    type: 'critical',
    parameter: 'Cobre T',
    message: 'Nivel de cobre excesivamente alto',
    value: 5.8,
    unit: 'mg/L Cu',
    optimalRange: '0.1-5',
    date: '2024-01-09',
    time: '17:30',
    technician: 'Ana Martín',
    resolved: true,
    resolution: 'Tratamiento quelante aplicado y fuente de contaminación identificada',
    resolutionTime: '4h 20min'
  },
  {
    id: '10',
    type: 'warning',
    parameter: 'pH T',
    message: 'pH ligeramente por encima del rango óptimo',
    value: 8.5,
    unit: 'pH',
    optimalRange: '6.5-8.4',
    date: '2024-01-08',
    time: '10:00',
    technician: 'María García',
    resolved: true,
    resolution: 'Ajuste con ácido muriático completado',
    resolutionTime: '1h 30min'
  }
];

export const alertTrends = [
  { date: '09/01', critical: 2, warning: 3, resolved: 4 },
  { date: '10/01', critical: 1, warning: 4, resolved: 3 },
  { date: '11/01', critical: 0, warning: 2, resolved: 2 },
  { date: '12/01', critical: 3, warning: 1, resolved: 3 },
  { date: '13/01', critical: 1, warning: 3, resolved: 4 },
  { date: '14/01', critical: 2, warning: 2, resolved: 3 },
  { date: '15/01', critical: 1, warning: 1, resolved: 2 },
  { date: '16/01', critical: 0, warning: 2, resolved: 2 },
  { date: '17/01', critical: 1, warning: 1, resolved: 2 },
  { date: '18/01', critical: 0, warning: 1, resolved: 1 },
  { date: '19/01', critical: 1, warning: 2, resolved: 3 }
];
